// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import CustomerOrderListPagingResultModel from '../../model/customer-order-list-paging-result-model';
import CustomerOrderListPagingResultDTO from '../dto/customer-order-list-paging-result-dto';
import CustomerOrderListModel from '../../model/customer-order-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class CustomerOrderListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<CustomerOrderListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => CustomerOrderListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  'items'?: CustomerOrderListModel[];
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  */
  'paginationData'?: PaginationDataModel;

  static toModel(dto: DeepPartial<CustomerOrderListPagingResultDTO>): CustomerOrderListPagingResultModel;
  static toModel(dto: DeepPartial<CustomerOrderListPagingResultDTO> | undefined | null): CustomerOrderListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<CustomerOrderListPagingResultDTO> | undefined | null): CustomerOrderListPagingResultModel | undefined {
    return dto ? new CustomerOrderListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<CustomerOrderListPagingResultModel> | CustomerOrderListPagingResultModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'items': unwrapped.items,
      'links': unwrapped.links,
      'paginationData': unwrapped.paginationData,
    } as CustomerOrderListPagingResultDTO;
  }
}
